import * as service from './service'
export default {
  namespace: 'honourKnightHistory',
  state: {
    recordData: [],
    notice: null
  },
  effects: {
    * knightHistory ({ payload }, { call, put, select }) {
      const res = yield call(service.getHonourHistory, payload)

      console.log('%cgetData', 'font-size:20px; color: lightblue;')
      console.log(res)
      console.log(res.data.data.data)
      console.log(res.data.data.notice)
      console.log('%cgetData', 'font-size:20px; color: lightblue;')

      const recordData = yield select(state => {
        return state.honourKnightHistory.recordData
      })
      if (res.status === 200 && res.data.status === 200) {
        yield put({
          type: 'save',
          payload: {
            recordData: res.data.data.data,
            notice: res.data.data.notice
          }
        })
        return res.data.data.data
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
